import { configureStore } from '@reduxjs/toolkit';
import globalSlice from './globalSlice';
import userSlice from './userSlice';
import blogReducer      from '../features/blog/blogSlice';
import categoryReducer  from '../features/blog/categorySlice';
import tagReducer       from '../features/blog/tagSlice';
import commentReducer   from '../features/blog/commentSlice';
import mediaReducer     from '../features/blog/mediaSlice';
import analyticsReducer from '../features/blog/analyticsSlice';
import seoReducer       from '../features/seo/seoSlice';
import redirectReducer  from '../features/blog/redirectSlice';
import activityReducer  from '../features/blog/activitySlice';

export const store = configureStore({
  reducer: {
    global    : globalSlice,
    user      : userSlice,
    blog      : blogReducer,
    category  : categoryReducer,
    tag       : tagReducer,
    comment   : commentReducer,
    media     : mediaReducer,
    analytics : analyticsReducer,
    seo       : seoReducer,
    redirect  : redirectReducer,
    activity  : activityReducer,
  },
})
